/** Word the user types to confirm deletion when the account has no email. */
export const DELETE_CONFIRMATION_WORD = 'delete';

/**
 * Picks what the user must type to confirm deleting their account.
 *
 * @param accountEmail - The signed-in Auth user's email. Null, undefined, or
 *   blank for accounts without one (some SSO and Canvas sign-ins).
 * @return The trimmed account email, or `DELETE_CONFIRMATION_WORD` when the
 *   account has no email.
 * @throws Never.
 */
export function getDeleteConfirmationPhrase(
  accountEmail: string | null | undefined,
): string {
  const email = accountEmail?.trim() ?? '';
  return email === '' ? DELETE_CONFIRMATION_WORD : email;
}

/**
 * Checks whether the typed confirmation matches the phrase from
 * `getDeleteConfirmationPhrase`, ignoring surrounding whitespace and case.
 *
 * @param typed - What the user typed; null or undefined never matches.
 * @param accountEmail - The signed-in Auth user's email, as for
 *   `getDeleteConfirmationPhrase`.
 * @return True when the deletion may proceed.
 * @throws Never.
 */
export function isDeleteConfirmationMatch({
  typed,
  accountEmail,
}: {
  typed: string | null | undefined;
  accountEmail: string | null | undefined;
}): boolean {
  const expected = getDeleteConfirmationPhrase(accountEmail).toLowerCase();
  return (typed ?? '').trim().toLowerCase() === expected;
}
